<template>
    <div class="form-row">
        <div class="form-group col-md-2">
            <label class="f-w-b">{{customer.is_foreign ? 'ID' : (isCompany ? 'CNPJ' : 'CPF')}}</label>
            <input type="text" readonly class="form-control-plaintext form-control-sm" :value="formatDocument">
        </div>
        <div class="form-group col-md-3">
            <label class="f-w-b">Cidade/Estado</label>
            <input type="text" readonly class="form-control-plaintext form-control-sm" :value="cityState">
        </div>
        <div class="form-group col-md-3">
            <label class="f-w-b">Endereço</label>
            <input type="text"
                   readonly
                   class="form-control-plaintext form-control-sm"
                   :value="`${customer.address}${customer.address_number ? ', ' + customer.address_number : ''} - CEP: ${$appUtils.formatPostalCode(customer.postal_code)}`">
        </div>
        <div class="form-group col-md-2">
            <label class="f-w-b">Bairro</label>
            <input type="text" readonly class="form-control-plaintext form-control-sm" :value="customer.neighborhood">
        </div>
        <div class="form-group col-md-2">
            <label class="f-w-b">Inscri. Est.</label>
            <input type="text" readonly class="form-control-plaintext form-control-sm" :value="customer.inscricao_estadual">
        </div>
    </div>
</template>

<script>
    import {formatDocument} from "../../utils/Utils";

    export default {
        name: "CustomerDetail",
        props: {
            customer: {
                type: Object,
                required: true
            }
        },
        computed: {
            isCompany() {
                return (this.customer.document || '').replace(/\D/g, '').length === 14;
            },
            cityState() {
                if (this.customer.is_foreign) {
                    return this.customer.city.name + '/' +  this.customer.city.state.name + '/' +  this.customer.city.state.country.name
                }

                return this.customer.city.name + '/' +  this.customer.city.state.acronym
            },
            formatDocument() {
                if (this.customer.is_foreign) return this.customer.document;

                return formatDocument(this.customer.document)
            }
        }
    }
</script>
